"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebViewLoadInfo = exports.SubsequentNavigationType = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
/** Navigation types for webview subsequent navigation */
var SubsequentNavigationType;
(function (SubsequentNavigationType) {
    /** TYPE_UNSET - Unset default. */
    SubsequentNavigationType[SubsequentNavigationType["TYPE_UNSET"] = 0] = "TYPE_UNSET";
    /** OTHER - Navigation is taking place for some other reason. */
    SubsequentNavigationType[SubsequentNavigationType["OTHER"] = 1] = "OTHER";
    /** LINK_ACTIVATED - A link with an href attribute was activated by the user */
    SubsequentNavigationType[SubsequentNavigationType["LINK_ACTIVATED"] = 2] = "LINK_ACTIVATED";
    /** BACK_FORWARD - An item from the back-forward list was requested. */
    SubsequentNavigationType[SubsequentNavigationType["BACK_FORWARD"] = 3] = "BACK_FORWARD";
    /** RELOAD - The webpage was reloaded. */
    SubsequentNavigationType[SubsequentNavigationType["RELOAD"] = 4] = "RELOAD";
    SubsequentNavigationType[SubsequentNavigationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SubsequentNavigationType = exports.SubsequentNavigationType || (exports.SubsequentNavigationType = {}));
function createBaseWebViewLoadInfo() {
    return {
        domDownloadLatencyMillis: undefined,
        domLoadLatencyMillis: undefined,
        firstContentfulPaintLatency: undefined,
        fullLoadLatency: undefined,
        loadProgress: undefined,
        hasSubsequentNavigation: undefined,
        resourcesLoadedFromCache: undefined,
        resourcesLoadedFromNetwork: undefined,
        resourcesLoadedSizeBytes: undefined,
        browserUserAgent: undefined,
        pageUrl: undefined,
        cssResourcesCacheLoad: undefined,
        scriptResourcesCacheLoad: undefined,
        imgResourcesCacheLoad: undefined,
        linkResourcesCacheLoad: undefined,
        cssResourcesNetworkLoad: undefined,
        scriptResourcesNetworkLoad: undefined,
        imgResourcesNetworkLoad: undefined,
        linkResourcesNetworkLoad: undefined,
        webviewInitializeStartTsMs: undefined,
        webviewInitializeEndTsMs: undefined,
        webviewLoadUrlTsMs: undefined,
        webviewNavigationStartTsMs: undefined,
        htmlResponseStartLatencyMs: undefined,
        domInteractiveLatencyMs: undefined,
        domContentLoadedStartLatencyMs: undefined,
        domCompleteLatencyMs: undefined,
        perfMetricsPageUrl: undefined,
        webviewInitializedSuccessfully: undefined,
        webviewInitializeErrorReason: undefined,
        webviewNavigationFinishTsMs: undefined,
        subNavigationTypes: [],
        htmlResolveServerRedirectCount: undefined,
        htmlResolveServerRedirectCompleteTsMs: undefined,
        serverRedirectResolvedUrl: undefined,
        hasPostClickEngagement: undefined,
    };
}
exports.WebViewLoadInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.domDownloadLatencyMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.domDownloadLatencyMillis }, writer.uint32(10).fork()).ldelim();
        }
        if (message.domLoadLatencyMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.domLoadLatencyMillis }, writer.uint32(18).fork()).ldelim();
        }
        if (message.firstContentfulPaintLatency !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.firstContentfulPaintLatency }, writer.uint32(26).fork()).ldelim();
        }
        if (message.fullLoadLatency !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.fullLoadLatency }, writer.uint32(34).fork()).ldelim();
        }
        if (message.loadProgress !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.loadProgress }, writer.uint32(42).fork()).ldelim();
        }
        if (message.hasSubsequentNavigation !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.hasSubsequentNavigation }, writer.uint32(50).fork()).ldelim();
        }
        if (message.resourcesLoadedFromCache !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.resourcesLoadedFromCache }, writer.uint32(58).fork()).ldelim();
        }
        if (message.resourcesLoadedFromNetwork !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.resourcesLoadedFromNetwork }, writer.uint32(66).fork()).ldelim();
        }
        if (message.resourcesLoadedSizeBytes !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.resourcesLoadedSizeBytes }, writer.uint32(74).fork()).ldelim();
        }
        if (message.browserUserAgent !== undefined) {
            wrappers_1.StringValue.encode({ value: message.browserUserAgent }, writer.uint32(82).fork()).ldelim();
        }
        if (message.pageUrl !== undefined) {
            wrappers_1.StringValue.encode({ value: message.pageUrl }, writer.uint32(90).fork()).ldelim();
        }
        if (message.cssResourcesCacheLoad !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.cssResourcesCacheLoad }, writer.uint32(98).fork()).ldelim();
        }
        if (message.scriptResourcesCacheLoad !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.scriptResourcesCacheLoad }, writer.uint32(106).fork()).ldelim();
        }
        if (message.imgResourcesCacheLoad !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.imgResourcesCacheLoad }, writer.uint32(114).fork()).ldelim();
        }
        if (message.linkResourcesCacheLoad !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.linkResourcesCacheLoad }, writer.uint32(122).fork()).ldelim();
        }
        if (message.cssResourcesNetworkLoad !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.cssResourcesNetworkLoad }, writer.uint32(130).fork()).ldelim();
        }
        if (message.scriptResourcesNetworkLoad !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.scriptResourcesNetworkLoad }, writer.uint32(138).fork()).ldelim();
        }
        if (message.imgResourcesNetworkLoad !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.imgResourcesNetworkLoad }, writer.uint32(146).fork()).ldelim();
        }
        if (message.linkResourcesNetworkLoad !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.linkResourcesNetworkLoad }, writer.uint32(154).fork()).ldelim();
        }
        if (message.webviewInitializeStartTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.webviewInitializeStartTsMs }, writer.uint32(162).fork()).ldelim();
        }
        if (message.webviewInitializeEndTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.webviewInitializeEndTsMs }, writer.uint32(170).fork()).ldelim();
        }
        if (message.webviewLoadUrlTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.webviewLoadUrlTsMs }, writer.uint32(178).fork()).ldelim();
        }
        if (message.webviewNavigationStartTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.webviewNavigationStartTsMs }, writer.uint32(186).fork()).ldelim();
        }
        if (message.htmlResponseStartLatencyMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.htmlResponseStartLatencyMs }, writer.uint32(194).fork()).ldelim();
        }
        if (message.domInteractiveLatencyMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.domInteractiveLatencyMs }, writer.uint32(202).fork()).ldelim();
        }
        if (message.domContentLoadedStartLatencyMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.domContentLoadedStartLatencyMs }, writer.uint32(210).fork()).ldelim();
        }
        if (message.domCompleteLatencyMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.domCompleteLatencyMs }, writer.uint32(218).fork()).ldelim();
        }
        if (message.perfMetricsPageUrl !== undefined) {
            wrappers_1.StringValue.encode({ value: message.perfMetricsPageUrl }, writer.uint32(226).fork()).ldelim();
        }
        if (message.webviewInitializedSuccessfully !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.webviewInitializedSuccessfully }, writer.uint32(234).fork()).ldelim();
        }
        if (message.webviewInitializeErrorReason !== undefined) {
            wrappers_1.StringValue.encode({ value: message.webviewInitializeErrorReason }, writer.uint32(242).fork()).ldelim();
        }
        if (message.webviewNavigationFinishTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.webviewNavigationFinishTsMs }, writer.uint32(250).fork()).ldelim();
        }
        writer.uint32(258).fork();
        for (const v of message.subNavigationTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.htmlResolveServerRedirectCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.htmlResolveServerRedirectCount }, writer.uint32(266).fork()).ldelim();
        }
        if (message.htmlResolveServerRedirectCompleteTsMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.htmlResolveServerRedirectCompleteTsMs }, writer.uint32(274).fork()).ldelim();
        }
        if (message.serverRedirectResolvedUrl !== undefined) {
            wrappers_1.StringValue.encode({ value: message.serverRedirectResolvedUrl }, writer.uint32(282).fork()).ldelim();
        }
        if (message.hasPostClickEngagement !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.hasPostClickEngagement }, writer.uint32(290).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebViewLoadInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.domDownloadLatencyMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.domLoadLatencyMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.firstContentfulPaintLatency = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.fullLoadLatency = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.loadProgress = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.hasSubsequentNavigation = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.resourcesLoadedFromCache = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.resourcesLoadedFromNetwork = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.resourcesLoadedSizeBytes = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.browserUserAgent = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 11:
                    message.pageUrl = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 12:
                    message.cssResourcesCacheLoad = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 13:
                    message.scriptResourcesCacheLoad = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 14:
                    message.imgResourcesCacheLoad = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 15:
                    message.linkResourcesCacheLoad = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 16:
                    message.cssResourcesNetworkLoad = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 17:
                    message.scriptResourcesNetworkLoad = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 18:
                    message.imgResourcesNetworkLoad = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 19:
                    message.linkResourcesNetworkLoad = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 20:
                    message.webviewInitializeStartTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 21:
                    message.webviewInitializeEndTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 22:
                    message.webviewLoadUrlTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 23:
                    message.webviewNavigationStartTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 24:
                    message.htmlResponseStartLatencyMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 25:
                    message.domInteractiveLatencyMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 26:
                    message.domContentLoadedStartLatencyMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 27:
                    message.domCompleteLatencyMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 28:
                    message.perfMetricsPageUrl = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 29:
                    message.webviewInitializedSuccessfully = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 30:
                    message.webviewInitializeErrorReason = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 31:
                    message.webviewNavigationFinishTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 32:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.subNavigationTypes.push(reader.int32());
                        }
                    }
                    else {
                        message.subNavigationTypes.push(reader.int32());
                    }
                    break;
                case 33:
                    message.htmlResolveServerRedirectCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 34:
                    message.htmlResolveServerRedirectCompleteTsMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 35:
                    message.serverRedirectResolvedUrl = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 36:
                    message.hasPostClickEngagement = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseWebViewLoadInfo();
        message.domDownloadLatencyMillis =
            object.domDownloadLatencyMillis ?? undefined;
        message.domLoadLatencyMillis = object.domLoadLatencyMillis ?? undefined;
        message.firstContentfulPaintLatency =
            object.firstContentfulPaintLatency ?? undefined;
        message.fullLoadLatency = object.fullLoadLatency ?? undefined;
        message.loadProgress = object.loadProgress ?? undefined;
        message.hasSubsequentNavigation =
            object.hasSubsequentNavigation ?? undefined;
        message.resourcesLoadedFromCache =
            object.resourcesLoadedFromCache ?? undefined;
        message.resourcesLoadedFromNetwork =
            object.resourcesLoadedFromNetwork ?? undefined;
        message.resourcesLoadedSizeBytes =
            object.resourcesLoadedSizeBytes ?? undefined;
        message.browserUserAgent = object.browserUserAgent ?? undefined;
        message.pageUrl = object.pageUrl ?? undefined;
        message.cssResourcesCacheLoad = object.cssResourcesCacheLoad ?? undefined;
        message.scriptResourcesCacheLoad =
            object.scriptResourcesCacheLoad ?? undefined;
        message.imgResourcesCacheLoad = object.imgResourcesCacheLoad ?? undefined;
        message.linkResourcesCacheLoad = object.linkResourcesCacheLoad ?? undefined;
        message.cssResourcesNetworkLoad =
            object.cssResourcesNetworkLoad ?? undefined;
        message.scriptResourcesNetworkLoad =
            object.scriptResourcesNetworkLoad ?? undefined;
        message.imgResourcesNetworkLoad =
            object.imgResourcesNetworkLoad ?? undefined;
        message.linkResourcesNetworkLoad =
            object.linkResourcesNetworkLoad ?? undefined;
        message.webviewInitializeStartTsMs =
            object.webviewInitializeStartTsMs ?? undefined;
        message.webviewInitializeEndTsMs =
            object.webviewInitializeEndTsMs ?? undefined;
        message.webviewLoadUrlTsMs = object.webviewLoadUrlTsMs ?? undefined;
        message.webviewNavigationStartTsMs =
            object.webviewNavigationStartTsMs ?? undefined;
        message.htmlResponseStartLatencyMs =
            object.htmlResponseStartLatencyMs ?? undefined;
        message.domInteractiveLatencyMs =
            object.domInteractiveLatencyMs ?? undefined;
        message.domContentLoadedStartLatencyMs =
            object.domContentLoadedStartLatencyMs ?? undefined;
        message.domCompleteLatencyMs = object.domCompleteLatencyMs ?? undefined;
        message.perfMetricsPageUrl = object.perfMetricsPageUrl ?? undefined;
        message.webviewInitializedSuccessfully =
            object.webviewInitializedSuccessfully ?? undefined;
        message.webviewInitializeErrorReason =
            object.webviewInitializeErrorReason ?? undefined;
        message.webviewNavigationFinishTsMs =
            object.webviewNavigationFinishTsMs ?? undefined;
        message.subNavigationTypes = object.subNavigationTypes?.map((e) => e) || [];
        message.htmlResolveServerRedirectCount =
            object.htmlResolveServerRedirectCount ?? undefined;
        message.htmlResolveServerRedirectCompleteTsMs =
            object.htmlResolveServerRedirectCompleteTsMs ?? undefined;
        message.serverRedirectResolvedUrl =
            object.serverRedirectResolvedUrl ?? undefined;
        message.hasPostClickEngagement = object.hasPostClickEngagement ?? undefined;
        return message;
    },
};
//# sourceMappingURL=webview_load_info.js.map